module.exports = __webpack_public_path__ + "img/contact-shape1.ee37b18a.svg";